import React from 'react';
import { withTranslation } from 'react-i18next';
import ListGroup from "../../../common/ListGroup";
import Loader from '../../../shared/components/Loader/Loader';
import axios from '../../../utils/axiosConfig';
import userSession from '../../../utils/userSession';
import './AvailableOffers.scss';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      availableOffers: [],
      loading: true,
      error: false
    };
  }

  componentDidMount() {
    this.fetchAvailableOffers();
  }

  componentDidUpdate(prevProps) {
    if (this.props.simulatedUserId != prevProps.simulatedUserId) {
      this.setState({ loading: true });
      this.fetchAvailableOffers();
    }
  }

  fetchAvailableOffers() {
    const userId = userSession('id');

    userId && axios.get(`/api/v1/influencers/influencers/${userId}/available_offers.json`)
      .then((response) => { this.setState({ availableOffers: response.data, loading: false, error: false }); })
      .catch(error => { this.setState({ loading: false, error: true }); });
  }

  render() {
    let { availableOffers, error, loading } = this.state;
    const userId = userSession('id');
    const { t } = this.props;

    if (!userId) {
      return (
        <div></div>
      );
    }

    if (loading || error) {
      return <Loader loading={loading} error={error} />;
    }

    return (
      <div className="info-section available-offers">
        {availableOffers.length == 0 &&
          <React.Fragment>
            <div className="new-opportunities-title">
              <h4>{t('influencers.pages.home.new_opportunities')}</h4>
            </div>
            <div className="no-available-offers" dangerouslySetInnerHTML={
              { __html: t('influencers.pages.home.no_opportunities', { interpolation: { escapeValue: true } }) }
            } />
          </React.Fragment>
        }
        {availableOffers.length > 0 &&
          <ListGroup title={t('influencers.pages.home.new_opportunities')}
            objects={availableOffers}
            objectType='offer'
            listGroupKey='available-offers'
            loading={loading}
            error={error}
          />
        }
      </div>
    );
  }
}

export default withTranslation()(Home);
